import { updatePrescriptionTags } from "../services/update-prescription-tags";
import { usePrescriptionMutation } from "./use-prescription-mutation";

export function useUpdatePrescriptionTags() {
  return usePrescriptionMutation({
    mutationFn: updatePrescriptionTags,
    successMessage: "Updated successfully",
    errorMessage: (error) =>
      (error as Error)?.message || "Failed to update doctor decision",
  });
}
